import { Component } from '@opten/compiler/metadata/component';
import getParentWithClass from '@opten/dom/get-parent-with-class';
import scrollToElement from '@opten/scroll/scroll-to-element';

@Component({ className: 'js-scroll-next-module' })
export class ScrollNextModule {
	constructor(private element: HTMLElement) {
		const module = getParentWithClass(element, 'c-module');

		element.addEventListener('click', () => scrollToElement(module.nextElementSibling));
	}
}
